import { PlaceFeatureKey } from './places-features.constants'

// Note: only these switches have a description in `organisation:places.features.descriptions`
export const DESCRIBED_FEATURE_KEYS = [
  'aiWriterAvailable',
  'amenitiesAcrAvailable',
  'amenityLocationAvailable',
  'amenityMarketplaceAvailable',
  'amenityPassesAvailable',
  'amenityReservations',
  'amenityRewardsAvailable',
  'appUserStatusAvailable',
  'assetTrackingAvailable',
  'buildingAnalyticsAvailable',
  'buildingEssentialsAvailable',
  'chatAvailable',
  'chatCustom',
  'chatFD',
  'chatMT',
  'chatPM',
  'checklistsAvailable',
  'communicateSMSAvailable',
  'communicationAvailable',
  'communityCalendar',
  'customAccessAvailable',
  'customerPortalAvailable',
  'displayBuildingNumber',
  'eventTicketsAvailable',
  'fitnessAvailable',
  'frontDeskAvailable',
  'groupsAvailable',
  'groupsPostReview',
  'guestAccess',
  'homepageAvailable',
  'incidentReportsAvailable',
  'inspectionsAvailable',
  'loyaltyAvailable',
  'maintenanceCallAvailable',
  'maintenanceEscalationAvailable',
  'maintenanceRequestAvailable',
  'managementUsersAvailable',
  'manualApproval',
  'marketShopAvailable',
  'marketShopRestaurantAvailable',
  'mealMeAvailable',
  'packageRoomAvailable',
  'packagesAvailable',
  'packagesD2DAvailable',
  'packagesQuickScanAvailable',
  'parkingManagementAvailable',
  'perksAvailable',
  'physicalKeyAvailable',
  'qrCodeSurveysAvailable',
  'rentAvailable',
  'reputationAvailable',
  'requiredScheduledDate',
  'residentEventsAvailable',
  'restaurantManagerAvailable',
  'rewardsAvailable',
  'servicesAvailable',
  'tvAppAvailable',
  'valetAvailable',
  'verifyPhoneNumber',
  'visitorParkingAvailable',
  'widgetChatAvailable',
] as const satisfies readonly PlaceFeatureKey[]

export type DescribedFeatureKey = (typeof DESCRIBED_FEATURE_KEYS)[number]

const DESCRIBED = new Set<string>(DESCRIBED_FEATURE_KEYS)

export const hasFeatureDescription = (key: string): key is DescribedFeatureKey => DESCRIBED.has(key)
